import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface AutoPaymentSettingsResponse {
  id: number
  familyUserId: number
  districtId: number
  autoPayEnabled: boolean
  allContractsEnabled: boolean
  contInvoiceDueDate: boolean
  lunchEnabled: boolean
  standaloneInvoicesEnabled: boolean
  studentFeeSimpleEnabled: boolean
  // `dayOfMonth` is always a number on the wire. When `contInvoiceDueDate` is true
  // the backend stores the "no scheduled day" sentinel (0) — UI code should treat
  // that as "no scheduled day" rather than the literal day 0.
  dayOfMonth: number
  fundingSourceId: number
}

// Configured on the admin System Configuration page. Restricts the day-of-month
// the auto-pay settings UI can offer. Absent / unconfigured → {min:1, max:31}
// (no restriction).
export interface AutoPaymentDayRange {
  min: number
  max: number
}

export interface AutoPaymentSettingsFetchResult {
  settings: AutoPaymentSettingsResponse | null
  range: AutoPaymentDayRange
}

export const autoPaymentSettings = async (
  districtId: TDistrictId
): Promise<AutoPaymentSettingsFetchResult> => {
  const response = await new Request().get('/ajax/auto_payment_settings/get/' + districtId)
  console.log('API response', response.data)

  const rawSettings = response.data.auto_payment_settings
  const settings = rawSettings
    ? (Util.Obj.keysToCamel(rawSettings) as AutoPaymentSettingsResponse)
    : null

  const rawRange = response.data.auto_pay_day_range || {}
  const range: AutoPaymentDayRange = {
    min: Number(rawRange.min) || 1,
    max: Number(rawRange.max) || 31
  }

  return { settings, range }
}
